import TagEmpty from '../../src/legacy/TagEmpty.tsx';
export default TagEmpty;
